import { Box, Typography } from '@mui/material';
import { useState } from 'react';
import Product from '../models/Product';
import ProductBar from '../Components/ProductBar';

interface HardwareProps {
  includeDetails: boolean;
}

function HardwarePage(props: HardwareProps) {
  const [productsList] = useState<Product[]>([
    // OAPHTNI2610-LC
    { name: 'HITECH CPU', price: 100, description: 'Intel Core i5, 12th Gen Intel Processor, 8GB RAM DDR4, 1TB HDD', category: 'IT Hardware', currency: 'PKR', imgPath: '/cpu.png' },
    { name: 'Gaming PC', price: 50, description: "Intel Core iSeries (i3, i5 and i7 available), Standard 8GB RAM (upto 32GB available), 480GB S.S.D, 1TB SATA-II Storage", category: 'IT Hardware', currency: 'PKR', imgPath: '/gaming-pc-solo.png' },
    { name: 'Styal Tab', price: 100, description: 'ARM Cortex-A55 OCta Processor, Core 1.6 Ghz UniSoc Sc9863a, Android Version 9 (Pie), Screen Size 8" Inch, RAM 2 GB, Internal Memory 32 GB, MicroS Card support', category: 'IT Hardware', currency: 'PKR', imgPath: '/styal-tabs.png' },
    { name: 'Gaming PC + Keyboard Set', price: 100, description: 'Includes OneApple USB Waterproof Keyboard and OneApple Optical USB Mouse', category: 'IT Hardware', currency: 'PKR', imgPath: '/gaming-pc-and-keyboard.png' },
    { name: 'All Rounder Set', price: 50, description: 'PC + Keyboard + Mouse', category: 'IT Hardware', currency: 'PKR', imgPath: '/pc-keyboard-mouse-set.png' }
  ]);


  return (
    <Box>
      <Typography sx={{marginBottom: "40px", backgroundColor:'#fce5cc', width: '100%', color:'#432308'}} fontFamily={'Georgia'} fontSize={40} variant="h2">technology</Typography>
      <ProductBar products={productsList} extended={props.includeDetails} />
    </Box>
  );
}

export default HardwarePage;